import { render } from "./JustRouterView.vue?vue&type=template&id=76d85a1c&ts=true"
import script from "./JustRouterView.vue?vue&type=script&lang=ts"
export * from "./JustRouterView.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/prod_sara2/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__